// extracted by mini-css-extract-plugin
export default {"video_container":"video_video_container__WA2Gn","vect":"video_vect__xDwFj","video":"video_video__SU8KM","back_ground_img":"video_back_ground_img__9vpxj"};